export enum TournamentRoles {
  // ASSISTANT_CHAIR_UMPIRE = 'Assistant Chair umpire',
  SUPERVISOR = 'Supervisor',
  CHIEF_OF_OFFICIALS = 'Chief of Officials',
  REFEREE = 'Referee',
  REVIEW_OFFICIAL = 'Review official',
  CHAIR_UMPIRE = 'Chair umpire',
  LINE_UMPIRE = 'Line umpire',
  ROVING_UMPIRE = 'Roving umpire',
  // HEAD_PLUS_LINE_UMPIRE = 'Head plus line umpire',
}
